import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PublicIcon from '@material-ui/icons/Public';
const DownloadShareModal = ({downloadShareData, onDownloadShareData, onFieldChange, toggleModalFn}) => {
  return(
    <Dialog
      open={downloadShareData.modal}
      onClose={() => toggleModalFn(false)}
      aria-labelledby="scroll-dialog-title"
      fullWidth= 'true'
    >
      <DialogTitle id="scroll-dialog-title">
        Download Data
      </DialogTitle>
      <DialogContent dividers={true} className="data-upload-modal">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div style={{border:'1px solid #a78701', background:'#fff1b6', padding:'5px', borderRadius:'3px'}}>
              <p style={{fontSize:'13px', color:'#2f2600'}}>
                Generating your download link is a background process.{downloadShareData?.dataRoom? ' We':' Enter your email address below and we'} will send you the link once it is ready.
                <br/> 
               <br/> Approximate timings for link generation:
               {<>
                <br/>~10GB: 15mins
                <br/>~100GB: 80mins
                <br/>~300GB: 140mins
                </>
               }
                <br/> 
               <br/>Once you hit Continue, you may safely refresh this page — however, do not click Download again as it will restart the process and cause a loop.
              </p>
            </div>
            {downloadShareData?.dataRoom ?null:
            <div>
              <TextField
                required
                id="email"
                fullWidth
                margin="normal"
                value={downloadShareData.email}
                onChange={(e) => onFieldChange(e.target.value)}
                label="Email"
                placeholder="Please enter email"
                InputLabelProps={{shrink: true}}
              />
            </div>}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => toggleModalFn(false)}>Cancel</Button>
        <Button onClick={()=>{onDownloadShareData(); toggleModalFn(false)}} disabled={downloadShareData?.dataRoom ?false: downloadShareData?.email?.trim().length ? false:true} variant="contained" color="primary">Continue</Button>
      </DialogActions>
    </Dialog>
  )
}
export default DownloadShareModal;
